<template>
    <sgwg-content width="420" heigth="600">
        <v-list-item>

            <sg-widget-icon height="36" width="36" class="mr-3" />

            <v-list-item-content>
                <v-list-item-title class="headline">
                    Узнать лицевой счет
                </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
                <v-btn icon @click.stop="close(false)" large>


                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>

        <sgwg-find-out-account ref="find-out-account" @find="close($event)" />
    </sgwg-content>
</template>

<script>
    import SgwgContent from '@/components/SgwgContent'
    import SgWidgetIcon from '@/components/SgWidgetIcon'
    import SgwgFindOutAccount from './SgwgFindOutAccount'

    export default {
        components: {
            SgwgContent,
            SgWidgetIcon,
            SgwgFindOutAccount
        },
        methods: {


            close(account) {

                let route = {
                    name: 'search'
                }


                if (!!account) {
                    route.params = {
                        initAccount: account
                    }
                }

                this.$router.push(route)

                this.postMessage('dialog:close')
            }

            
        }
    }
</script>

<style>

</style>